// Generated by Ktorfit
@file:Suppress("warnings")

package com.bikompanion.`data`

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress

@OptIn(InternalKtorfitApi::class)
public class _CityBikesApiImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : CityBikesApi {
  override suspend fun getNetworks(): CityBikesNetworksResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "networks")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<CityBikesNetworksResponse>(),)!! 
  }

  override suspend fun getNetworkDetail(id: String, fields: String): CityBikesNetworkDetailResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "networks/${"$id".encodeURLPath()}")
        fields?.let{ parameter("fields", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<CityBikesNetworkDetailResponse>(),)!! 
  }
}

public class _CityBikesApiProvider : ClassProvider<CityBikesApi> {
  override fun create(_ktorfit: Ktorfit): CityBikesApi = _CityBikesApiImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createCityBikesApi(): CityBikesApi = _CityBikesApiImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
